import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@material-ui/core/styles';

import Button from '../button/Button';

const RADIUS = 4;

function getCtaButtonStyle (theme, { kind, accentColor, disabled }) {
    const isPrimary = kind === 'primary';
    const kindStyle = isPrimary
        ? { backgroundColor: accentColor || theme.palette.primary.main, color: '#ffffff', borderRadius: RADIUS }
        : { backgroundColor: theme.palette.background.paper, color: theme.palette.grey[800], borderColor: theme.palette.grey[100], borderRadius: RADIUS };

    if (disabled) {
        kindStyle.backgroundColor = 'rgba(0, 0, 0, 0.12)';
    }

    return kindStyle;
}

function CtaButton ({ kind, accentColor, style, className, children, ...rest }) {
    const theme = useTheme();
    const kindStyle = getCtaButtonStyle(theme, { kind, accentColor, disabled: rest.disabled });

    return (
        <Button
            color="Primary"
            variant={kind === 'primary' ? 'contained' : 'outlined'}
            style={{ ...kindStyle, ...style }}
            className={className}
            {...rest}
        >
            {children}
        </Button>
    );
}

CtaButton.propTypes = {
    kind: PropTypes.oneOf(['primary', 'secondary']),
    accentColor: PropTypes.string,
    style: PropTypes.object,
    className: PropTypes.string,
    children: PropTypes.node,
};

CtaButton.defaultProps = {
    kind: 'secondary',
    accentColor: null,
};

export default CtaButton;
